module.exports = __webpack_public_path__ + "img/실시간.0ed28f7a.png";